import { Button, Group, Modal, Select, Space, TextInput } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconFilter, IconFilterCancel } from "@tabler/icons-react";
import { ChangeEvent, useCallback, useState } from "react";

export interface FiltroLicenciada {
  search: string;
  campo: string;
}

const emptyFilter: FiltroLicenciada = {
  search: "",
  campo: ""
};

const camposDisponiveis = [
  { value: "razaoSocial", label: "Razão Social" },
  { value: "cnpj", label: "CNPJ" },
  { value: "responsavel", label: "Responsável" },
  { value: "cidade", label: "Cidade" },
  { value: "uf", label: "UF" }
];

interface ModalFilterLicenciadasProperties {
  setFilter: React.Dispatch<React.SetStateAction<FiltroLicenciada>>;
}

const ModalFilterLicenciadas = ({ setFilter }: ModalFilterLicenciadasProperties) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [values, setValues] = useState<FiltroLicenciada>(emptyFilter);

  const clearFiltro = useCallback(() => {
    setFilter(emptyFilter);
    setValues(emptyFilter);
  }, [setFilter]);

  const applyFilter = useCallback(() => {
    setFilter(values);
    setValues(emptyFilter);
    close();
  }, [setFilter, close, values]);

  const changeInput = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setValues((values) => ({ ...values, search: event.target.value }));
  }, []);

  const changeCampo = useCallback((campo: string | null) => {
    setValues((values) => ({ ...values, campo: campo || "" }));
  }, []);

  return (
    <>
      <Button variant="subtle" size="compact-md" leftSection={<IconFilter size="1rem" />} onClick={open}>
        Filtros
      </Button>
      <Button variant="subtle" size="compact-md" leftSection={<IconFilterCancel size="1rem" />} onClick={clearFiltro}>
        Limpar
      </Button>

      <Modal opened={opened} onClose={close} title="Filtrar Licenciadas">
        <Select
          label="Campo a ser filtrado"
          placeholder="Selecione um campo..."
          data={camposDisponiveis}
          value={values.campo}
          onChange={changeCampo}
          clearable
        />

        <Space h="md" />

        <TextInput
          label="Texto a ser procurado"
          placeholder="Digite o texto para buscar..."
          value={values.search}
          onChange={changeInput}
        />

        <Space h="xl" />

        <Group justify="flex-end">
          <Button variant="transparent" onClick={close}>
            Cancelar
          </Button>
          <Button variant="filled" onClick={applyFilter}>
            Filtrar
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ModalFilterLicenciadas;
